<script lang="ts">
  // The Timepeak logo as used on timepeak.nl: the official wordmark image
  // (dark text, or white on blue / in dark mode), or the bird mark alone.
  let { size = 28, wordmark = true, inverse = false }: { size?: number; wordmark?: boolean; inverse?: boolean } = $props();
</script>

{#if wordmark}
  <span class="logo" class:inverse style:height="{size}px">
    <img class="dark-text" src="/brand/logo-dark.webp" alt="Timepeak" height={size} width={Math.round(size * 4.59)} decoding="async" />
    <img class="light-text" src="/brand/logo-white.webp" alt="Timepeak" height={size} width={Math.round(size * 4.59)} decoding="async" />
  </span>
{:else}
  <img class="mark" src="/brand/mark.svg" alt="Timepeak" width={size} height={Math.round(size * 0.84)} decoding="async" />
{/if}

<style>
  .logo { display: inline-flex; align-items: center; }
  .logo img { height: 100%; width: auto; }
  /* Dark wordmark by default; the white one on blue (inverse) and in dark mode. */
  .dark-text { display: block; }
  .light-text, .inverse .dark-text { display: none; }
  .inverse .light-text { display: block; }
  :global([data-theme='dark']) .dark-text { display: none; }
  :global([data-theme='dark']) .light-text { display: block; }
  .mark { display: block; flex-shrink: 0; }
</style>
